import {Directive, ElementRef, HostListener, inject, input, InputSignal} from '@angular/core';

@Directive({
    selector: '[appCaseFormatter]',
})
export class CaseFormatterDirective {
    readonly el: ElementRef = inject(ElementRef);

    case: InputSignal<string> = input<string>('', {alias: 'appCaseFormatter'});

    @HostListener('input', ['$event']) onInput(event: Event) {
        const input = this.el.nativeElement as HTMLInputElement;
        if (this.case().toLowerCase() == 'lower') {
            input.value = input.value.toLowerCase()
        } else if (this.case().toLowerCase() == 'upper') {
            input.value = input.value.toUpperCase()
        }
    }
}
